import React from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/Button';
export function CloseButton(_ref) {
  var onClick = _ref.onClick;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Button, {
    icon: "x",
    variant: "transparent",
    onClick: onClick,
    title: t('actions_close_modal')
  });
}